import { useState, useRef, useEffect } from 'react';

interface ResizableDividerProps {
  onResize: (leftWidth: number) => void;
  initialLeftWidth?: number;
}

export function ResizableDivider({ onResize }: ResizableDividerProps) {
  const [isDragging, setIsDragging] = useState(false);
  const dividerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!isDragging || !dividerRef.current) return;

      const parent = dividerRef.current.parentElement;
      if (!parent) return;

      const parentRect = parent.getBoundingClientRect();
      const newLeftWidth = ((e.clientX - parentRect.left) / parentRect.width) * 100;

      // Limitar entre 20% e 80%
      const clampedWidth = Math.max(20, Math.min(80, newLeftWidth));
      onResize(clampedWidth);
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
  }, [isDragging, onResize]);

  return (
    <div
      ref={dividerRef}
      className={`relative flex-shrink-0 w-1 bg-gray-300 dark:bg-schmersal-gray-dark hover:bg-blue-500 dark:hover:bg-schmersal-blue cursor-col-resize transition-colors ${isDragging ? 'bg-blue-500 dark:bg-schmersal-blue' : ''
        }`}
      onMouseDown={(e) => {
        e.preventDefault();
        setIsDragging(true);
      }}
      style={{ minWidth: '4px', maxWidth: '4px' }}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-0.5 h-8 bg-gray-400 dark:bg-schmersal-gray-light rounded" />
      </div>
    </div>
  );
}

